import BaseColumnsStrategy from '../BaseColumnsStrategy'

export default function HTMLColumnsStrategy() {}

HTMLColumnsStrategy.prototype = new BaseColumnsStrategy();

HTMLColumnsStrategy.prototype.init = function( timeformat )
{
    this.timeFormat = timeformat;
    BaseColumnsStrategy.prototype.init.call( this );
    return this;
};

HTMLColumnsStrategy.prototype.createTimeValueCell = function ( className )
{
    return ReportPreviewUtils.createCell( this.makeTimeValue(), "timeValueCell " + ( className ? className : "" ) );
};

HTMLColumnsStrategy.prototype.makeTimeValue = function()
{
    return ReportPreviewUtils.getHTMLTimeValue( this.timeFormat );
};

HTMLColumnsStrategy.prototype.createOthersHeaderCell = function( rowSpan )
{
    return ReportPreviewUtils.createCell( this.message("report.common.others"), "user", 1, rowSpan )
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/HTMLColumnsStrategy.js